<script>import { getFormField } from "../index.js";
export let tag = "p";
const { actions, errors, ids } = getFormField();
$:
  attrs = {
    "data-fs-validation": "",
    "data-fs-error": $errors ? "" : void 0,
    id: $ids.validation
  };
</script>

<svelte:element this={tag} use:actions.validation {...attrs} {...$$restProps}>
	{#if $errors}
		{$errors}
	{/if}
</svelte:element>
